import Block from '../block'

export default class Filter extends Block {
	static title = 'filter'

	constructor($el) {
		super($el)

		this.form = this.$el.findElement('form')
		this.select = this.$el.findElement('select')

		if (this.form && this.select) {
			this.select.on('sl-change', () => {
				this.form.submit()
			})
		}
	}
}
